<template>
  <div>
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="1000" v-model="alertShow" width="fit-content" top centered>
      <v-alert
          v-model="alertShow"
          dismissible
          :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-cancel'"
          class="mb-0 pa-1"
          :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
          light
          close-icon="mdi-close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <div class="game-banner hidden-md-and-down" style="position: relative;">
<!--      <div class="menuBar" v-if="isLoggedIn" style="padding: 0 12%;">-->
<!--        <div class="menuBarWrapper">-->
<!--          <app-member-menu-bar></app-member-menu-bar>-->
<!--        </div>-->
<!--      </div>-->
      <!-- <v-carousel class="banner" cycle delimiter-icon="panorama_fish_eye" :show-arrows="false" interval="10000" height="auto">
          <v-carousel-item v-for="(banner, i) in bannerContent" :key="i">
              <v-img :src="`${banner.desktop_banner}`" @click="callBannerAction(banner.action)" :contain="true" :aspect-ratio="3"></v-img>
          </v-carousel-item>
      </v-carousel> -->
      <v-img class="align-end" :src="`${bannerUrl}/vip/desktop/${language}.jpg`"></v-img>

      <!--      <div class="img-vip">-->
      <!--        <v-img class="" width="600" height="160" :src="`${mediaUrl}/game_banner/no1.png`"></v-img>-->
      <!--      </div>-->
      <!--      <div class="text-vip">-->
      <!--        <p class="joinVipText pb-5">{{ $t(`label.joinVip2`) }}</p>-->
      <!--        &lt;!&ndash;        <p class="joinVipText">{{ $t(`label.joinVip3`) }}</p>&ndash;&gt;-->
      <!--      </div>-->
    </div>
    <div class="vip-tiermobile hidden-lg-and-up">
      <v-img class="align-end" :src="`${bannerUrl}/vip/mobile/${language}.jpg`"></v-img>
      <div class="align-end pb-3 vip-tier-mobile-banner">
        <div class="text-container">
          <v-img class="pb-3" width="100%" height="220px" :src="`${mediaUrl}/game_banner/be_vip.png`" >
            <v-row style="" no-gutters class="d-flex justify-center align-end px-3">
              <v-row no-gutters class="beVipText">
                <v-col cols="12" class="pa-0 d-flex align-center justify-center">
                  <span class="white--text text-center">
                    <h3 class="headertext">{{ $t(`label.beVip`) }}</h3>
                  </span>
                </v-col>
                <v-col cols="12" class="pa-0 d-flex align-center justify-center">
                  <span class="white--text text-center">
                    <p class="descriptionVipText">{{ $t(`label.beVipDes1`) }}</p>
                  </span>
                </v-col>
                <v-col cols="12" class="pa-0 d-flex align-center justify-center">
                  <span class="white--text text-center">
                    <p class="descriptionVipText">{{ $t(`label.beVipDes2`) }}</p>
                  </span>
                </v-col>
                <v-col cols="12" class="pa-0 d-flex align-center justify-center">
                  <span class="white--text text-center">
                    <p class="descriptionVipText mb-0">{{ $t(`label.beVipDes3`) }}</p>
                    <p class="descriptionVipText">{{ $t(`label.beVipDes4`) }}</p>
                  </span>
                </v-col>
              </v-row>
            </v-row>
          </v-img>
        </div>
      </div>
      <div class="mt-2 pb-3 vip-tier-mobile">
        <!--        <v-img class="align-center" :aspect-ratio="1800 / 650" :src="`${mediaUrl}/game_banner/be_vip_desktop.jpg`">-->
        <v-row no-gutters>
          <v-img class="" :src="`${mediaUrl}/game_banner/be_vip.png`">
            <v-row no-gutters style="height: 100%">
              <v-col cols="6" class="d-flex align-center justify-center">
                <v-col cols="9" class="pa-0">
                  <div class="be-vip white--text">
                    <h3 class="bevipheader">{{ $t(`label.belb88Vip`) }}</h3>
                  </div>
                </v-col>
              </v-col>
              <v-col cols="6" class="d-flex align-center">
                <v-col cols="10" class="pa-0">
                  <div class="be-vip white--text">
                    <p class="descriptionVipText">{{ $t(`label.beVipDes1`) }}</p>
                    <p class="descriptionVipText">{{ $t(`label.beVipDes2`) }}</p>
                    <p class="descriptionVipText mb-0">{{ $t(`label.beVipDes3`) }}</p>
                    <p class="descriptionVipText">{{ $t(`label.beVipDes4`) }}</p>
                  </div>
                </v-col>
              </v-col>
            </v-row>
          </v-img>
        </v-row>
      </div>
      <v-row no-gutters>
        <v-col cols="12" class="MB-right-col d-flex align-center pt-3">
          <v-row class="justify-center align-center" no-gutters>
            <v-col cols="1" class="pa-0">
              <v-btn @click="showPreviousLevel" class="btnleft pt-6" style="min-width: 10px;">
                <
              </v-btn>
            </v-col>

            <v-col cols="1" class="pa-0 d-flex mr-2 flex-column align-center">
              <v-row no-gutters class="justify-center pt-4" v-if="getImageSrc('past2') !== ''">
                <span class="nameCoverETC">{{ truncatedItemName($t(`label.${getImageSrc('past2')}`)) }}</span>
              </v-row>
              <v-row no-gutters class="align-items-center justify-center tierpngHalf">
                <v-avatar tile class="tier-nextPass" width="100%" height="100%">
                  <v-img class="otherTierImage" :src="`${getImageSrcHalfRight('past2')}`" eager></v-img>
                </v-avatar>
              </v-row>
            </v-col>
            <v-col cols="2" class="pa-0 d-flex flex-column align-center">
              <v-row no-gutters class="justify-center pt-4" v-if="getImageSrc('past') !== ''">
                <span class="nameCoverETC ml-1">{{ truncatedItemName($t(`label.${getImageSrc('past')}`)) }}</span>
              </v-row>
              <v-row no-gutters class="align-items-center justify-center tierpng">
                <v-avatar tile class="" width="100%" height="100%">
                  <v-img class="otherTierImage" :src="`${mediaUrl}/vipTier/${getImageSrc('past')}.png?a`" eager></v-img>
                </v-avatar>
              </v-row>
            </v-col>
            <v-col cols="3" class="py-0 d-flex flex-column align-center">
              <v-row no-gutters class="justify-center pt-4">
                <span class="nameCover" :class="getTextColor()">{{ $t(`label.${getTextColor()}`) }}</span>
              </v-row>
              <v-row no-gutters class="align-items-center justify-center tierpng">
                <v-avatar tile class="" width="100%" height="100%">
                  <v-img :src="`${mediaUrl}/vipTier/${getTextColor()}.png?a`" eager></v-img>
                </v-avatar>
              </v-row>
            </v-col>
            <v-col cols="2" class="pa-0 d-flex flex-column align-center">
              <v-row no-gutters class="justify-center pt-4" v-if="getImageSrc('next') !== ''">
                <span class="nameCoverETC mr-1">{{ truncatedItemName($t(`label.${getImageSrc('next')}`)) }}</span>
              </v-row>
              <v-row no-gutters class="align-items-center justify-center tierpng">
                <v-avatar tile class="" width="100%" height="100%">
                  <v-img class="otherTierImage" :src="`${mediaUrl}/vipTier/${getImageSrc('next')}.png?a`" eager></v-img>
                </v-avatar>
              </v-row>
            </v-col>
            <v-col cols="1" class="pa-0 ml-2 d-flex flex-column align-center">
              <v-row no-gutters class="justify-center pt-4" v-if="getImageSrc('next2') !== ''">
                <span class="nameCoverETC">{{ truncatedItemName($t(`label.${getImageSrc('next2')}`)) }}</span>
              </v-row>
              <v-row no-gutters class="align-items-center justify-center tierpngHalf">
                <v-avatar tile class="tier-nextPass" width="100%" height="100%">
                  <v-img class="otherTierImage" :src="`${getImageSrcHalfLeft('next2')}`" eager></v-img>
                </v-avatar>
              </v-row>
            </v-col>

            <v-col cols="1" class="pa-0">
              <v-btn @click="showNextLevel" class="btnright pt-6" style="min-width: 10px;">
                >
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
<!--        <v-col cols="12">-->
<!--          <v-row no-gutters class="align-items-center justify-center ">-->
<!--            <v-avatar tile class="" width="93px" height="auto" style="transform: scale(1.2); marign-left: 5px;">-->
<!--              <v-img :src="`${mediaUrl}/vipTier/bottomFloor.png?a`" eager></v-img>-->
<!--            </v-avatar>-->
<!--          </v-row>-->
<!--        </v-col>-->
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters class="row-border">
            <v-col cols="12" class="col-padding">
              <span class="headerTable white--text">{{ $t(`label.vipReqBenefit`) }}</span>
            </v-col>
          </v-row>
          <div class="coveredRow">
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="col-padding">
                <span class="headerTable white--text">{{ $t(`label.vipUpgrade`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText"></v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span class="white--text">{{ $t(`label.monthlyDepositRequirement`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span class="white--text">{{ $t(currentTierDetails.oneMonthDeposits) }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span class="white--text">{{ $t(`label.monthlyTurnoverRequirement`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span class="white--text">{{ $t(currentTierDetails.monthlyTurnover) }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span class="white--text">{{ $t(`label.tierUpgradeBonusOneOff`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span class="white--text">{{ formatCurrency(currentTierDetails.tierUpgradeBonusOneOff) }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span class="white--text">{{ $t(`label.upgradeBonusTurnover`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span class="white--text">{{ currentTierDetails.upgradeBonusTurnover }}</span>
              </v-col>
            </v-row>
          </div>
          <div class="uncoveredRow">
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="col-padding">
                <span class="headerTable">{{ $t(`label.vipBenefits`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText"></v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span>{{ $t(`label.autoDepositBonus`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span>{{ currentTierDetails.autoDepositBonus }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span>{{ $t(`label.birthdayBonus`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span>{{ formatCurrency(currentTierDetails.bdBonuses) }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span>{{ $t(`label.slotsInstantTurnoverRebate`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span>{{ currentTierDetails.slotsInstantTurnoverRebate }}%</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span>{{ $t(`label.liveCasinoTableInstantTurnoverRebate`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span>{{ currentTierDetails.liveCasinoTableInstantTurnoverRebate }}%</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span>{{ $t(`label.crashTurnoverRebate`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span>{{ currentTierDetails.crashInstantTurnoverRebate }}%</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span>{{ $t(`label.sportsTurnoverRebate`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span>{{ currentTierDetails.sportsInstantTurnoverRebate }}%</span>
              </v-col>
            </v-row>
          </div>
          <div class="coveredRow">
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span class="white--text">{{ $t(`label.retentionRequirement`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText"></v-col>
            </v-row>
            <v-row no-gutters class="row-border">
              <v-col cols="8" class="tableText col-border">
                <span class="white--text">{{ $t(`label.monthlyRetentionRequirement`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span class="white--text">{{ $t(currentTierDetails.monthlyRetention) }}</span>
              </v-col>
            </v-row>
          </div>
          <div class="uncoveredRow">
            <v-row no-gutters>
              <v-col cols="8" class="tableText col-border">
                <span>{{ $t(`label.memberRenewal`) }}</span>
              </v-col>
              <v-col cols="4" class="col-padding border_left tableText">
                <span>{{ $t(`label.${currentTierDetails.memberRenewal}`) }}</span>
              </v-col>
            </v-row>
          </div>
          <v-row no-gutters class="d-flex justify-center align-center mt-5 mb-5">
            <v-col cols="8" class="pa-0 justify-center align-center">
              <v-btn height="auto" width="100%" class="text-uppercase pa-3 findMoreButton" @click="goToPromotionVipTier()">{{ $t(`label.findOutMore`) }}</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters class="coveredRow pa-4 mt-3">
        <div class="faq-tnc-container">
          <v-btn class="tncbtn" width="100%" style="text-transform: none !important;" @click="toggleTnc">
            <span class="faqspan tncFaqTitle font-weight-bold">{{ $t(`label.faqVipTitle`) }}</span>
            <div :class="['triangle', showTnc ? 'down' : 'up']"></div>
          </v-btn>
          <v-expand-transition>
            <div v-if="showTnc" class="px-4 pb-4 pt-2">
              <p class="pp white--text font-weight-bold pb-2 tncFaqTitle">{{ $t(`label.faqViptier1a`) }}</p>
              <p class="pp pp-dot white--text">{{ $t(`label.faqViptier1b`) }}</p>
              <ul>
                <li class="pp white--text">{{ $t(`label.faqViptier1b`) }}</li>
              </ul>
              <p class="pp white--text font-weight-bold pb-2 tncFaqTitle">{{ $t(`label.faqViptier2a`) }}</p>
              <ul>
                <li class="pp white--text">{{ $t(`label.faqViptier2b`) }}</li>
              </ul>
              <p class="pp white--text font-weight-bold pb-2 tncFaqTitle">{{ $t(`label.faqViptier3a`) }}</p>
              <ul>
                <li class="pp white--text">{{ $t(`label.faqViptier3b`) }}</li>
              </ul>
              <p class="pp white--text font-weight-bold pb-2 tncFaqTitle">{{ $t(`label.faqViptier4a`) }}</p>
              <ul>
                <li class="pp white--text">{{ $t(`label.faqViptier4b`) }}</li>
              </ul>
              <p class="pp white--text font-weight-bold pb-2 tncFaqTitle">{{ $t(`label.faqViptier5a`) }}</p>
              <ul>
                <li class="pp white--text">{{ $t(`label.faqViptier5b`) }}</li>
              </ul>
            </div>
          </v-expand-transition>
        </div>
        <div class="faq-tnc-container mt-3">
          <v-btn class="faqbtn" width="100%" style="text-transform: none !important;" @click="toggleFaq">
            <span class="faqspan tncFaqTitle font-weight-bold">{{ $t(`label.tncViptitle`) }}</span>
            <div :class="['triangle', showFaq ? 'down' : 'up']"></div>
          </v-btn>
          <v-expand-transition>
            <div v-if="showFaq" class="px-4 pb-4 pt-2">
              <p class="pp white--text pb-2">{{ $t(`label.tncViptierA`) }}</p>
              <p class="pp white--text pb-2">{{ $t(`label.tncViptierB`) }}</p>
              <p class="pp white--text pb-2">{{ $t(`label.tncViptierC`) }}</p>
            </div>
          </v-expand-transition>
        </div>
      </v-row>
    </div>

    <div class="hidden-md-and-down">
      <div style="background: #fff;">
        <div class="align-center py-5" style="background-color: rgba(245, 245, 245, 1)">
          <v-row style="padding: 1% 10%" no-gutters class="d-flex justify-center">
            <span class="black--text joinVipText">{{ $t(`label.minDepoMonth`) }}</span>
          </v-row>
          <v-row style="padding: 0% 4% 0%" no-gutters class="d-flex justify-space-around">
            <div v-for="(image, index) in imagesVip" :key="index" class="level-col">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0 ma-0">
                  <div class="d-flex flex-column justify-center align-center">
                    <v-row no-gutters style="max-width: 220px">
                      <v-img :src="image.src"></v-img>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-row>
          <v-row style="padding: 0% 4% 2%" no-gutters class="d-flex justify-space-around">
            <div v-for="(image, index) in imagesVip" :key="index" class="level-col">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0 ma-0">
                  <div class="d-flex flex-column justify-center align-center" style="width: 220px">
                    <v-row no-gutters>
                      <span class="black--text font-weight-bold" style="font-size: 20px">{{ $t(`label.${image.name}`) }}</span>
                    </v-row>
                    <v-row no-gutters>
                      <span class="black--text">{{ image.amount }}</span>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-row>
<!--          <v-row style="padding: 0% 12%" no-gutters class="d-flex justify-space-around">-->
<!--            <v-row no-gutters>-->
<!--              <v-col cols="12" class="pa-0 ma-0">-->
<!--                <div class="d-flex flex-column justify-center align-center">-->
<!--                  <v-row no-gutters :style="{ 'max-width': '245px' }">-->
<!--                    <v-img :src="`${mediaUrl}/vipTier/bottomFloor.png`"></v-img>-->
<!--                  </v-row>-->
<!--                </div>-->
<!--              </v-col>-->
<!--            </v-row>-->
<!--          </v-row>-->
        </div>
        <div>
          <v-row no-gutters>
            <v-img class="" :src="`${mediaUrl}/game_banner/be_vip.png`">
              <v-row no-gutters style="height: 100%">
                <v-col cols="6" class="d-flex align-center justify-center">
                  <v-col cols="9" class="pa-0">
                    <div class="be-vip white--text">
                      <h3 class="bevipheader">{{ $t(`label.belb88Vip`) }}</h3>
                    </div>
                  </v-col>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-col cols="7" class="pa-0">
                    <div class="be-vip white--text">
                      <p class="descriptionVipText">{{ $t(`label.beVipDes1`) }}</p>
                      <p class="descriptionVipText">{{ $t(`label.beVipDes2`) }}</p>
                      <p class="descriptionVipText mb-0">{{ $t(`label.beVipDes3`) }}</p>
                      <p class="descriptionVipText">{{ $t(`label.beVipDes4`) }}</p>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
            </v-img>
          </v-row>
        </div>
        <div class="vip-tierdesktop">
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0"></v-col>
            <v-col cols="9" class="cols-border d-flex text-center pa-0 ">
              <v-col class="border_left pb-1 pa-0" v-for="(name, index) in tierImages" :key="index">
                <p class="righttextdesktop ma-0"><v-img :src="name.src" width="60" height="60"></v-img></p>
              </v-col>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0"></v-col>
            <v-col cols="9" class="d-flex text-center pa-0 ">
              <v-col class="border_left pb-5 pa-0" v-for="(image, index) in tierImages" :key="index">
                <p class="righttextdesktop ma-0 level-Names" :class="image.name">{{ $t(`label.${image.name}`) }}</p>
              </v-col>
            </v-col>
          </v-row>
          <div class="vipTable_bg">
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0">
                <h1 class="lefttextdesktop font-weight-bold pl-6 category-Title">{{ $t(`label.vipUpgrade`) }}</h1>
              </v-col>
              <v-col cols="9" class="d-flex text-center pa-0 ">
                <v-col class="border_left pa-0" v-for="(empty, index) in empties" :key="index">
                  <p class="righttextdesktop ma-0">{{ empty }}</p>
                </v-col>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0">
                <p class="lefttextdesktop pl-6">{{ $t(`label.monthlyDepositRequirement`) }}</p>
              </v-col>
              <v-col cols="9" class="d-flex text-center pa-0">
                <v-col class="border_left pa-0" v-for="(req, index) in oneMonthDeposits" :key="index">
                  <p class="righttextdesktop ma-0">{{ $t(req) }}</p>
                </v-col>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0">
                <p class="lefttextdesktop pl-6">{{ $t(`label.monthlyTurnoverRequirement`) }}</p>
              </v-col>
              <v-col cols="9" class="d-flex text-center pa-0">
                <v-col class="border_left pa-0" v-for="(req, index) in monthlyTurnover" :key="index">
                  <p class="righttextdesktop ma-0">{{ $t(req) }}</p>
                </v-col>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0">
                <p class="lefttextdesktop pl-6">{{ $t(`label.tierUpgradeBonusOneOff`) }}</p>
              </v-col>
              <v-col cols="9" class="d-flex text-center pa-0">
                <v-col class="border_left pa-0" v-for="(req, index) in tierUpgradeBonusOneOff" :key="index">
                  <p class="righttextdesktop ma-0">{{ req }}</p>
                </v-col>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0">
                <p class="lefttextdesktop pl-6">{{ $t(`label.upgradeBonusTurnover`) }}</p>
              </v-col>
              <v-col cols="9" class="d-flex text-center pa-0">
                <v-col class="border_left pa-0" v-for="(bonus, index) in upgradeBonusTurnover" :key="index">
                  <p class="righttextdesktop ma-0">{{ bonus }}</p>
                </v-col>
              </v-col>
            </v-row>
          </div>
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0">
              <p class="lefttextdesktop black--text font-weight-bold pl-6 category-Title">{{ $t(`label.vipBenefits`) }}</p>
            </v-col>
            <v-col cols="9" class="d-flex text-center pa-0 ">
              <v-col class="border_left pa-0" v-for="(empty, index) in empties" :key="index">
                <p class="righttextdesktop ma-0">{{ empty }}</p>
              </v-col>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0">
              <p class="lefttextdesktop black--text pl-6">{{ $t(`label.autoDepositBonus`) }}</p>
            </v-col>
            <v-col cols="9" class="d-flex text-center pa-0">
              <v-col class="border_left pa-0" v-for="(bonus, index) in autoDepositBonus" :key="index">
                <p class="righttextdesktop black--text ma-0">{{ bonus }}</p>
              </v-col>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0">
              <p class="lefttextdesktop black--text pl-6">{{ $t(`label.birthdayBonus`) }}</p>
            </v-col>
            <v-col cols="9" class="d-flex text-center pa-0">
              <v-col class="border_left pa-0" v-for="(bonus, index) in bdBonuses" :key="index">
                <p class="righttextdesktop black--text ma-0">{{ bonus }}</p>
              </v-col>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0">
              <p class="lefttextdesktop black--text pl-6">{{ $t(`label.slotsInstantTurnoverRebate`) }}</p>
            </v-col>
            <v-col cols="9" class="d-flex text-center pa-0">
              <v-col class="border_left pa-0" v-for="(bonus, index) in slotsInstantTurnoverRebate" :key="index">
                <p class="righttextdesktop black--text ma-0">{{ bonus }}</p>
              </v-col>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0">
              <p class="lefttextdesktop black--text pl-6">{{ $t(`label.liveCasinoTableInstantTurnoverRebate`) }}</p>
            </v-col>
            <v-col cols="9" class="d-flex text-center pa-0">
              <v-col class="border_left pa-0" v-for="(bonus, index) in liveCasinoTableInstantTurnoverRebate" :key="index">
                <p class="righttextdesktop black--text ma-0">{{ bonus }}</p>
              </v-col>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0">
              <p class="lefttextdesktop black--text pl-6">{{ $t(`label.crashTurnoverRebate`) }}</p>
            </v-col>
            <v-col cols="9" class="d-flex text-center pa-0">
              <v-col class="border_left pa-0" v-for="(bonus, index) in crashInstantTurnoverRebate" :key="index">
                <p class="righttextdesktop black--text ma-0">{{ bonus }}</p>
              </v-col>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0">
              <p class="lefttextdesktop black--text pl-6">{{ $t(`label.sportsTurnoverRebate`) }}</p>
            </v-col>
            <v-col cols="9" class="d-flex text-center pa-0">
              <v-col class="border_left pa-0" v-for="(bonus, index) in sportsInstantTurnoverRebate" :key="index">
                <p class="righttextdesktop black--text ma-0">{{ bonus }}</p>
              </v-col>
            </v-col>
          </v-row>
          <div class="vipTable_bg">
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0">
                <p class="lefttextdesktop font-weight-bold pl-6 category-Title">{{ $t(`label.retentionRequirement`) }}</p>
              </v-col>
              <v-col cols="9" class="d-flex text-center pa-0 ">
                <v-col class="border_left pa-0" v-for="(empty, index) in empties" :key="index">
                  <p class="righttextdesktop ma-0">{{ empty }}</p>
                </v-col>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0">
                <p class="lefttextdesktop pl-6">{{ $t(`label.monthlyRetentionRequirement`) }}</p>
              </v-col>
              <v-col cols="9" class="d-flex text-center pa-0">
                <v-col class="border_left pa-0" v-for="(req, index) in monthlyRetention" :key="index">
                  <p class="righttextdesktop ma-0">{{ $t(req) }}</p>
                </v-col>
              </v-col>
            </v-row>
          </div>
          <div class="">
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0">
                <p class="lefttextdesktop black--text pl-6 category-Title">{{ $t(`label.memberRenewal`) }}</p>
              </v-col>
              <v-col cols="9" class="d-flex text-center pa-0">
                <v-col class="border_left pa-0" v-for="(renewal, index) in memberRenewal" :key="index">
                  <p class="righttextdesktop black--text ma-0">{{ $t(`label.${renewal.toLowerCase()}`) }}</p>
                </v-col>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-row no-gutters class="d-flex justify-center align-center mt-2 mb-5">
          <v-col cols="3" class="pa-0 justify-center align-center">
            <v-btn height="80px" width="100%" class="text-uppercase pa-3 findMoreButton" @click="goToPromotionVipTier()">{{ $t(`label.findOutMore`) }}</v-btn>
          </v-col>
        </v-row>
        <v-img class="" style="" :aspect-ratio="1600 / 350" :src="`${mediaUrl}/vipTier/vipTierBackground.png`">
          <v-row no-gutters class="d-flex justify-space-around py-16" style="position: relative; padding: 2% 12% !important;">
            <v-col cols="6" class="tncFaqCol pa-5">
              <h2 style="font-size: 18px;display: flex; padding-bottom: 20px; color: #fff">{{ $t(`label.faqVipTitle`) }}</h2>
              <p class="pp pb-2 font-weight-bold">{{ $t(`label.faqViptier1a`) }}</p>
              <ul>
                <li class="pp pb-2">{{ $t(`label.faqViptier1b`) }}</li>
              </ul>
              <p class="pp pb-2 font-weight-bold">{{ $t(`label.faqViptier2a`) }}</p>
              <ul>
                <li class="pp pb-2">{{ $t(`label.faqViptier2b`) }}</li>
              </ul>
              <p class="pp pb-2 font-weight-bold">{{ $t(`label.faqViptier3a`) }}</p>
              <ul>
                <li class="pp pb-2">{{ $t(`label.faqViptier3b`) }}</li>
              </ul>
              <p class="pp pb-2">{{ $t(`label.faqViptier4a`) }}</p>
              <ul>
                <li class="pp pb-2">{{ $t(`label.faqViptier4b`) }}</li>
              </ul>
              <p class="pp pb-2">{{ $t(`label.faqViptier5a`) }}</p>
              <ul>
                <li class="pp pb-2">{{ $t(`label.faqViptier5b`) }}</li>
              </ul>
            </v-col>
            <div class="border_left "></div>
            <v-col cols="6" class="tncFaqCol pa-5 white--text">
              <v-row no-gutters style="width: 80%;">
                <h2 style="font-size: 18px;display: flex; padding-bottom: 20px;">{{ $t(`label.tncViptitle`) }}</h2>
                <p class="pp pb-2">{{ $t(`label.tncViptierA`) }}</p>
                <p class="pp pb-5">{{ $t(`label.tncViptierB`) }}</p>
                <p class="pp">{{ $t(`label.tncViptierC`) }}</p>
              </v-row>
            </v-col>
          </v-row>
        </v-img>
      </div>
    </div>
    <!--    <div class="hidden-lg-and-up"></div>-->
  </div>
</template>

<script>
import VueQrCode from 'vue-qrcode-component'
import AppLoginEmbedded from '@/components/member/loginEmbedded.vue'
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper, locale, errorCodeHelper, formValidator } from '@/util'
import { SHARED } from '@/constants/constants'
import { REFERRAL_GET_OVERVIEW, REFERRAL_POST_COMMISSION, REFERRAL_RESET_COMMISSION, REFERRAL_GET_CONFIG } from '@/store/referral.module'
import stringFormat from 'string-format'
import currencySymbolMapp from 'currency-symbol-map'
import { MEMBER_WALLET, MEMBER_VIP_TIER_PROGRESS } from '@/store/member.module'
import AppMemberMenuBar from '@/components/layout/MemberMenuBar.vue'
export default {
  name: 'viptier',
  metaInfo: {
    title: `${locale.getMessage('meta.vip_title')}`,
    titleTemplate: `%s | ${uiHelper.getHost()}`,
    meta: [
      { charset: 'utf-8' },
      {
        name: 'description',
        content: `${locale.getMessage('meta.vip_description')}`
      },
      { name: 'keyword', content: `${locale.getMessage('meta.default_keyword')}` }
    ]
  },
  components: {
    AppMemberMenuBar,
    VueQrCode,
    AppLoginEmbedded
  },
  data: () => ({
    wordLimit: 3,
    currentIndex: 0,
    isFirstTier: false,
    isLastTier: false,
    currentTierIndex: 0,
    vipTierTabs: {
      newmember: 'Member',
      bronze: 'Bronze',
      silver: 'Silver',
      ruby: 'Ruby',
      gold: 'Gold',
      platinimum: 'Platinimum',
      diamond: 'Diamond'
    },
    tierSettingsDetail: {
      newmember: {
        autoDepositBonus: '3.50%',
        oneMonthDeposits: '',
        monthlyTurnover: '',
        tierUpgradeBonusOneOff: '',
        upgradeBonusTurnover: '',
        bdBonuses: '188',
        slotsInstantTurnoverRebate: '0.50',
        liveCasinoTableInstantTurnoverRebate: '0.20',
        crashInstantTurnoverRebate: '0.30',
        sportsInstantTurnoverRebate: '0.20',
        monthlyRetention: '',
        memberRenewal: 'lifetime',
      },
      bronze: {
        autoDepositBonus: '3.50%',
        oneMonthDeposits: '৳35,000',
        monthlyTurnover: 'None',
        tierUpgradeBonusOneOff: '288',
        upgradeBonusTurnover: 'x5',
        bdBonuses: '328',
        slotsInstantTurnoverRebate: '0.50',
        liveCasinoTableInstantTurnoverRebate: '0.30',
        crashInstantTurnoverRebate: '0.30',
        sportsInstantTurnoverRebate: '0.20',
        monthlyRetention: '৳40,000',
        memberRenewal: 'lifetime',
      },
      silver: {
        autoDepositBonus: '3.50%',
        oneMonthDeposits: '৳80,000',
        monthlyTurnover: '৳40,000',
        tierUpgradeBonusOneOff: '688',
        upgradeBonusTurnover: 'x6',
        bdBonuses: '888',
        slotsInstantTurnoverRebate: '0.60',
        liveCasinoTableInstantTurnoverRebate: '0.40',
        crashInstantTurnoverRebate: '0.40',
        sportsInstantTurnoverRebate: '0.30',
        monthlyRetention: '৳40,000',
        memberRenewal: 'monthly',
      },
      ruby: {
        autoDepositBonus: '4.00%',
        oneMonthDeposits: '৳150,000',
        monthlyTurnover: '৳75,000',
        tierUpgradeBonusOneOff: '1,288',
        upgradeBonusTurnover: 'x8',
        bdBonuses: '1,688',
        slotsInstantTurnoverRebate: '0.80',
        liveCasinoTableInstantTurnoverRebate: '0.50',
        crashInstantTurnoverRebate: '0.50',
        sportsInstantTurnoverRebate: '0.30',
        monthlyRetention: '৳75,000',
        memberRenewal: 'monthly',
      },
      gold: {
        autoDepositBonus: '4.00%',
        oneMonthDeposits: '৳300,000',
        monthlyTurnover: '৳150,000',
        tierUpgradeBonusOneOff: '2,888',
        upgradeBonusTurnover: 'x12',
        bdBonuses: '3,288',
        slotsInstantTurnoverRebate: '1.00',
        liveCasinoTableInstantTurnoverRebate: '0.80',
        crashInstantTurnoverRebate: '0.50',
        sportsInstantTurnoverRebate: '0.30',
        monthlyRetention: '৳150,000',
        memberRenewal: 'monthly',
      },
      platinium: {
        autoDepositBonus: '4.50%',
        oneMonthDeposits: '৳600,000',
        monthlyTurnover: '৳300,000',
        tierUpgradeBonusOneOff: '6,888',
        upgradeBonusTurnover: 'x15',
        bdBonuses: '5,288',
        slotsInstantTurnoverRebate: '1.00',
        liveCasinoTableInstantTurnoverRebate: '0.80',
        crashInstantTurnoverRebate: '0.50',
        sportsInstantTurnoverRebate: '0.30',
        monthlyRetention: '৳300,000',
        memberRenewal: 'monthly',
      },
      diamond: {
        autoDepositBonus: '5.00%',
        oneMonthDeposits: 'label.specialInvitation',
        monthlyTurnover: 'label.specialInvitation',
        tierUpgradeBonusOneOff: '8,888',
        upgradeBonusTurnover: 'x18',
        bdBonuses: '8,888',
        slotsInstantTurnoverRebate: '1.00',
        liveCasinoTableInstantTurnoverRebate: '0.80',
        crashInstantTurnoverRebate: '0.50',
        sportsInstantTurnoverRebate: '0.30',
        monthlyRetention: 'label.specialInvitation',
        memberRenewal: 'monthly',
      },
    },
    tab: null,
    viptiers: ['Bronze', 'Silver', 'Gold', 'Sapphire', 'Diamond', 'Platinum', 'Emerald'], // Array of rank names
    upgradeRequirement: ['Monthly Deposit Requirement', 'OR 3 Month accumulated'], // Array of label names
    stars: [1, 2, 3, 4, 5, 6, 7], // Array of star levels
    starRequirements: [10, 20, 30, 40, 50, 60, 70], // Array of star requirements (adjust as needed)
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    bannerUrl: `${SHARED.MEDIA_DOMAIN}/images/ctapp/banners`,
    showFaq: false,
    showTnc: false,
    dateOfBirthMenu: false,
    stringFormat: stringFormat,
    currencySymbolMapp: currencySymbolMapp,
    language: uiHelper.getLanguage(),
    currentCurrency: uiHelper.getCurrency(),
    validator: formValidator,
    shared: SHARED,
    selectedTab: 'tier',
    dates: ['', ''],
    overview: {},
    redeemCommissionAmt: 0.0,
    share_url: '',
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',
    images: [
      { id: 1, src: SHARED.MEDIA_SERVER_URL + '/vipTier/bronze.png', name: 'Bronze', amount: '৳60,000' },
      { id: 2, src: SHARED.MEDIA_SERVER_URL + '/vipTier/gold.png', name: 'Gold', amount: '৳300,000' },
      { id: 3, src: SHARED.MEDIA_SERVER_URL + '/vipTier/sapphire.png', name: 'Sapphire', amount: '৳1,000,000' },
      { id: 4, src: SHARED.MEDIA_SERVER_URL + '/vipTier/diamond.png', name: 'Diamond', amount: '৳5,000,000' },
      { id: 5, src: SHARED.MEDIA_SERVER_URL + '/vipTier/platinum.png', name: 'Platinum', amount: '৳3,000,000' },
      { id: 6, src: SHARED.MEDIA_SERVER_URL + '/vipTier/emerald.png', name: 'Emerald', amount: '৳500,000' },
      { id: 7, src: SHARED.MEDIA_SERVER_URL + '/vipTier/silver.png', name: 'Silver', amount: '৳125,000' }
    ],
    tiers: [
      { name: 'club', color: 'bronze', progress: 16.67 },
      { name: 'diamond', color: 'silver', progress: 33.33 },
      { name: 'heart', color: 'gold', progress: 50 },
      { name: 'spade', color: 'platinum', progress: 66.67 },
      { name: 'ace', color: 'diamond', progress: 83.33 },
      { name: 'raja', color: 'black', progress: 100 }
    ],
    notLoading: true,
    routeName: ROUTE_NAME,
    showProgress: false,
    tierBarBgColor: '',
    tierBarColor: '',
    tierColorThemeName: 'club',
    progressLevels: ['club', 'diamond', 'heart', 'spade', 'ace', 'raja'],
    currentProgress: 0,
    DesktopcurrentProgress: 0,
    tierName: '',
    currentProgressPercentage: 0,
    currentLv: 0,
    level: 1,
    tierImages: [
      { id: 1, src: SHARED.MEDIA_SERVER_URL + '/vipTier/newMember.png', name: 'newMember' },
      { id: 2, src: SHARED.MEDIA_SERVER_URL + '/vipTier/bronze.png', name: 'bronze' },
      { id: 3, src: SHARED.MEDIA_SERVER_URL + '/vipTier/silver.png', name: 'silver' },
      { id: 4, src: SHARED.MEDIA_SERVER_URL + '/vipTier/ruby.png', name: 'ruby' },
      { id: 5, src: SHARED.MEDIA_SERVER_URL + '/vipTier/gold.png', name: 'gold' },
      { id: 6, src: SHARED.MEDIA_SERVER_URL + '/vipTier/platinium.png', name: 'platinium' },
      { id: 7, src: SHARED.MEDIA_SERVER_URL + '/vipTier/diamond.png', name: 'diamond' }
    ],
    slotpercentages: ['0.10', '0.20', '0.30', '0.50', '0.80', '1.00'],
    casinopercentages: ['0.10', '0.20', '0.30', '0.50', '0.80', '1.00'],
    sportpercentages: ['0.10', '0.20', '0.30', '0.60', '0.80', '1.00'],
    freeCoinspercentages: [1, 1, 2, 5, 8, 10],
    turnoverrequirements: ['80,000', '2,500,000', 'N/A', 'N/A', 'N/A', 'Special Invitation'],
    upgradebonuses: ['200', '5,000', '20,000', '60,000', '100,00', 'Special Invitation'],
    downgradecriterias: ['N/A', 'N/A', 'Monthly Reset', 'Monthly Reset', 'Monthly Reset', 'Special Invitation'],
    // levelNames: [
    //   locale.getMessage('label.newMember'),
    //   locale.getMessage('label.bronze'),
    //   locale.getMessage('label.silver'),
    //   locale.getMessage('label.gold'),
    //   locale.getMessage('label.emerald'),
    //   locale.getMessage('label.sapphire'),
    //   locale.getMessage('label.platinum'),
    //   locale.getMessage('label.diamond')
    // ],
    levelName: ['newMember', 'bronze', 'silver', 'ruby', 'gold', 'platinium', 'diamond'],
    nextLv: 0,
    progressRequired: 0,
    empties: [' ', ' ', ' ', ' ', ' ', ' ', ' '],
    oneMonthDeposit: ['', '৳35,000', '৳80,000', '৳150,000', '৳300,000', '৳600,000', 'Special Invitation'],
    threeMonthDeposit: ['', '৳105,000', '৳375,000', '৳900,000', '৳1,500,000', '৳3,000,000', '৳9,000,000', '৳18,000,000'],
    upgradeBonus: ['', '৳688', '৳3,888', '৳5,888', '৳8,888', '৳18,888', '৳26,888', '৳32,888'],
    bdBonus: ['৳388', '৳688', '৳1,888', '৳3,888', '৳6,888', '৳12,888', '৳18,888', '৳26,888'],
    weeklyBonus: ['', '', '৳688', '৳888', '৳1,888', '৳3,888', '৳6,888', '৳8,888'],
    slotPercentages: ['', '0.30%', '0.40%', '0.50%', '0.60%', '0.70%', '0.80%', '1.00%'],
    otherPercentages: ['', '0.10%', '0.20%', '0.30%', '0.40%', '0.50%', '0.60%', '0.80%'],
    dedicatedVipLiveChat: [0, 0, 0, 1, 1, 1, 1, 1],
    depositWithdrawPriority: [0, 0, 0, 1, 1, 1, 1, 1],
    specialGift: [0, 0, 0, 1, 1, 1],
    csSupport: [0, 0, 0, 1, 1, 1],
    dnWPriority: [0, 0, 0, 0, 1, 1],
    vipEvents: [0, 0, 1, 1, 1, 1],
    exclusiveAccess: [0, 0, 0, 0, 0, 1],
    depositWithdrawOption: [0, 0, 0, 0, 0, 1, 1, 1],
    dedicatedVipManager: [0, 0, 0, 1, 1, 1],
    threeMonthDepositReq: ['', '', '৳187,500', '৳450,000', '৳750,000', '৳1,500,000', '৳4,500,000', '৳9,000,000'],
    threeMonthToReq: ['', '', '৳937,500', '৳2,250,000', '৳3,750,000', '৳7,500,000', '৳22,500,000', '৳45,000,000'],
    memberRenewal: ['Lifetime', 'Lifetime', 'Monthly', 'Monthly', 'Monthly', 'Monthly', 'Monthly']
  }),
  created() {
    // this.getVipTierProgress()
    this.metaTag()
    //this.tierSettingsDetail.diamond.monthlyDepositRequirement = this.monthlyDepositRequirementDiamond
    if (this.isLoggedIn) {
      this.getVipTierProgress()
    }
  },
  computed: {
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    },
    monthlyDepositRequirementDiamond() {
      return locale.getMessage('label.invitedonly')
    },
    imagesVip() {
      return [
        { id: 1, src: SHARED.MEDIA_SERVER_URL + '/vipTier/bronze.png', name: 'bronze', amount: '৳35,000' },
        { id: 2, src: SHARED.MEDIA_SERVER_URL + '/vipTier/silver.png', name: 'silver', amount: '৳80,000' },
        { id: 3, src: SHARED.MEDIA_SERVER_URL + '/vipTier/ruby.png', name: 'ruby', amount: '৳150,000' },
        { id: 4, src: SHARED.MEDIA_SERVER_URL + '/vipTier/gold.png', name: 'gold', amount: '৳300,000' },
        { id: 5, src: SHARED.MEDIA_SERVER_URL + '/vipTier/platinium.png', name: 'platinium', amount: '৳600,000' },
        { id: 6, src: SHARED.MEDIA_SERVER_URL + '/vipTier/diamond.png', name: 'diamond', amount: 'SPECIAL INVITATION' }
      ]
    },
    levelNames() {
      return [
        this.$t('label.newMember'),
        this.$t('label.bronze'),
        this.$t('label.silver'),
        this.$t('label.gold'),
        this.$t('label.emerald'),
        this.$t('label.sapphire'),
        this.$t('label.platinum'),
        this.$t('label.diamond')
      ]
    },
    currentTier() {
      return this.levelName[this.currentIndex]
    },
    currentTierDetails() {
      console.log(this.currentTier)
      return this.tierSettingsDetail[this.currentTier.toLowerCase()]
    },
    upgradeBonuses() {
      return ['', '388', '1,888', '3,888', '8,888', '18,888']
    },
    oneMonthDeposits() {
      return ['', '৳35,000', '৳80,000', '৳150,000', '৳300,000', '৳600,000', 'label.specialInvitation']
    },
    threeMonthDepositReqs() {
      return ['', '', '50,000', '125,000', '250,000', '500,000']
    },
    autoDepositBonus() {
      return ['3.50%', '3.50%', '3.50%', '4.00%', '4.00%', '4.50%', '5.00%']
    },
    bdBonuses() {
      return ['৳188', '৳328', '৳888', '৳1,688', '৳3,288', '৳5,288', '৳8,888']
    },
    depositRewardCoins() {
      return ['10%', '10%', '12%', '15%', '15%', '20%']
    },
    slotsInstantTurnoverRebate() {
      return ['0.50%', '0.50%', '0.60%', '0.80%', '1.00%', '1.00%', '1.00%']
    },
    liveCasinoTableInstantTurnoverRebate() {
      return ['0.20%', '0.30%', '0.40%', '0.50%', '0.80%', '0.80%', '0.80%']
    },
    crashInstantTurnoverRebate() {
      return ['0.30%', '0.30%', '0.40%', '0.50%', '0.50%', '0.50%', '0.50%']
    },
    sportsInstantTurnoverRebate() {
      return ['0.20%', '0.20%', '0.30%', '0.30%', '0.30%', '0.30%', '0.30%']
    },
    monthlyTurnover() {
      return ['', 'None', '৳40,000', '৳75,000', '৳150,000', '৳300,000', 'label.specialInvitation']
    },
    tierUpgradeBonusOneOff() {
      return ['', '৳288', '৳688', '৳1,288', '৳2,888', '৳6,888', '৳8,888']
    },
    upgradeBonusTurnover() {
      return ['', 'x5', 'x6', 'x8', 'x12', 'x15', 'x18']
    },
    monthlyRetention() {
      return ['', '', '৳40,000', '৳75,000', '৳150,000', '৳300,000', 'label.specialInvitation']
    },
    // capitalizedTierName() {
    //   return name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
    // },
    // slotpercentage() {
    //   const percentageMap = {
    //     1: '0.10%',
    //     2: '0.30%',
    //     3: '0.60%',
    //     4: '0.80%',
    //     5: '1.00%',
    //     6: '1.20%'
    //   }
    //   return percentageMap[this.level] || ''
    // },
    // casinopercentage() {
    //   const percentageMap = {
    //     1: '0.10%',
    //     2: '0.20%',
    //     3: '0.30%',
    //     4: '0.50%',
    //     5: '0.80%',
    //     6: '1.00%'
    //   }
    //   return percentageMap[this.level] || ''
    // },
    // sportpercentage() {
    //   const percentageMap = {
    //     1: '0.10%',
    //     2: '0.20%',
    //     3: '0.30%',
    //     4: '0.60%',
    //     5: '0.80%',
    //     6: '1.00%'
    //   }
    //   return percentageMap[this.level] || ''
    // },
    // freeCoinspercentage() {
    //   const percentageMap = {
    //     1: 1,
    //     2: 1,
    //     3: 2,
    //     4: 5,
    //     5: 8,
    //     6: 10
    //   }
    //
    //   let currentPrecent = percentageMap[this.level] || ''
    //   currentPrecent = currentPrecent + '%'
    //   //mkt request to use english as standard
    //   // if(currentPrecent!==''){
    //   //   //convert into locale string
    //   //   if(this.language==='bd'){
    //   //     currentPrecent = currentPrecent.toLocaleString('bn-BD')+'%'
    //   //   }else{
    //   //     currentPrecent = currentPrecent +'%'
    //   //   }
    //   // }
    //
    //   return currentPrecent
    // },
    // depositrequirement() {
    //   const percentageMap = {
    //     1: '10,000',
    //     2: '500,000',
    //     3: '3,000,000',
    //     4: '8,000,000',
    //     5: '15,000,000',
    //     6: 'Special Invitation'
    //   }
    //   return percentageMap[this.level] || ''
    // },
    // turnoverrequirement() {
    //   const percentageMap = {
    //     1: '80,000',
    //     2: '2,500,000',
    //     3: 'N/A',
    //     4: 'N/A',
    //     5: 'N/A',
    //     6: 'Special Invitation'
    //   }
    //   return percentageMap[this.level] || ''
    // },
    // upgradebonus() {
    //   const percentageMap = {
    //     1: '200',
    //     2: '5,000',
    //     3: '20,000',
    //     4: '60,000',
    //     5: '100,000',
    //     6: 'Special Invitation'
    //   }
    //   return percentageMap[this.level] || ''
    // },
    // downgradecriteria() {
    //   const percentageMap = {
    //     1: 'N/A',
    //     2: 'N/A',
    //     3: 'Monthly Reset',
    //     4: 'Monthly Reset',
    //     5: 'Monthly Reset',
    //     6: 'Special Invitation'
    //   }
    //   return percentageMap[this.level] || ''
    // },
    // imgSource() {
    //   return '/static/svg/vipassets/vip_' + this.tierColorThemeName + '.svg'
    // },
    // formattedValue() {
    //   const currencySymbol = this.currencySymbolMapp.currencySymbolMap[this.currentCurrency]
    //   const value = 10000
    //   return `${currencySymbol}${value}`
    // },
    // currentDate() {
    //   return new Date()
    // },
    // referralOverview() {
    //   return this.$store.state.referral.overview
    // },
    //
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
    // totalPoint() {
    //   return this.overview.downline_lv1 + this.overview.downline_lv2 + this.overview.downline_lv3
    // },
    // redeemCommissionDetailResponseComplete() {
    //   return this.$store.state.referral.redeemCommissionResponse.complete
    // },
    // referralConfig() {
    //   return this.$store.state.referral.config
    // },
    // memberInfo() {
    //   return this.$store.state.member.info
    // },
    // webShareApiSupported() {
    //   return navigator.share
    // },
    // memberVipTierProgress() {
    //   return this.$store.state.member.vipTierProgress.pairing
    // },
    // vipTierUpgrade() {
    //   return this.$store.state.member.vipTierProgress.upgrade
    // }
  },
  watch: {
    memberVipTierProgress() {
      this.currentIndex = this.memberVipTierProgress.level_sequence
    }
    // referralOverview() {
    //   this.overview = this.$store.state.referral.overview
    //   this.share_url = uiHelper.getHostname() + '?refer_code=' + this.overview.my_referral_code
    //   this.redeemCommissionAmt = this.$store.state.referral.overview.commission_balance.toFixed(2)
    // },
    // redeemCommissionDetailResponseComplete() {
    //   let response = this.$store.state.referral.redeemCommissionResponse
    //   if (response.complete) {
    //     this.redeemCommissionResponseCompleteDialog(response)
    //     this.$store.dispatch(`${REFERRAL_RESET_COMMISSION}`)
    //   }
    // },
    // memberVipTierProgress() {
    //   let vipTierProgress = this.$store.state.member.vipTierProgress
    //   if (Object.keys(vipTierProgress.pairing).length > 0) {
    //     let curPairing = vipTierProgress.pairing
    //     //progress found
    //     this.showProgress = true
    //     switch (curPairing.level_sequence) {
    //       case 1:
    //         this.tierColorThemeName = 'bronze'
    //         break
    //       case 2:
    //         this.tierColorThemeName = 'silver'
    //         break
    //       case 3:
    //         this.tierColorThemeName = 'gold'
    //         break
    //       case 4:
    //         this.tierColorThemeName = 'platinum'
    //         break
    //       default:
    //         this.tierColorThemeName = 'bronze'
    //         this.tierBarBgColor = '#1867c0'
    //     }
    //     this.tierBarBgColor = 'viptier' + this.tierColorThemeName
    //     this.tierName = curPairing.name
    //     this.currentLv = this.memberVipTGierProgress.level_sequence
    //     this.nextLv = this.memberVipTierProgress.level_sequence + 1
    //   } else {
    //     //no progress
    //     this.showProgress = false
    //   }
    // },
    // memberVipTierProgress() {
    //   let vipTierProgress = this.$store.state.member.vipTierProgress
    //   if (vipTierProgress && vipTierProgress.pairing) {
    //     if (Object.keys(vipTierProgress.pairing).length > 0) {
    //       let curPairing = vipTierProgress.pairing
    //       this.showProgress = true
    //       this.tierName = curPairing.name
    //       this.currentLv = curPairing.level_sequence
    //       this.nextLv = curPairing.level_sequence + 1
    //
    //       // Set current progress based on the level_sequence
    //       switch (curPairing.level_sequence) {
    //         case 1:
    //           ;(this.currentProgress = 11), (this.DesktopcurrentProgress = 13)
    //           break
    //         case 2:
    //           ;(this.currentProgress = 27), (this.DesktopcurrentProgress = 27)
    //           break
    //         case 3:
    //           ;(this.currentProgress = 44), (this.DesktopcurrentProgress = 44)
    //           break
    //         case 4:
    //           ;(this.currentProgress = 60), (this.DesktopcurrentProgress = 60)
    //           break
    //         case 5:
    //           ;(this.currentProgress = 78), (this.DesktopcurrentProgress = 78)
    //           break
    //         case 6:
    //           ;(this.currentProgress = 100), (this.DesktopcurrentProgress = 100)
    //           break
    //         default:
    //           ;(this.currentProgress = 0), (this.DesktopcurrentProgress = 0)
    //       }
    //     } else {
    //       this.showProgress = false
    //     }
    //   }
    // },
    //
    // isLoggedIn() {
    //   if (this.isLoggedIn) {
    //     this.getVipTierProgress()
    //   }
    // }
  },
  methods: {
    getVipTierProgress() {
      this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
    },
    goToPromotionVipTier() {
      this.$router.push({
        name: ROUTE_NAME.PROMOTION,
        params: { tab: 'vipPromotion' }
      })
    },
    truncatedItemName(itemName) {
      const charLimit = 3 // Set your desired character limit here
      if (itemName.length > charLimit) {
        return itemName.substring(0, charLimit) + '...'
      } else {
        return itemName
      }
    },
    toggleFaq() {
      this.showFaq = !this.showFaq
    },
    toggleTnc() {
      this.showTnc = !this.showTnc
    },
    getTextColor() {
      return this.currentTier ? this.currentTier : '' // Fallback
    },
    getTierIndex(state) {
      switch (state) {
        case 'past':
          return this.currentIndex > 0 ? this.currentIndex - 1 : null
        case 'past2':
          return this.currentIndex > 0 ? this.currentIndex - 2 : null
        case 'current':
          return this.currentIndex
        case 'next':
          return this.currentIndex < this.levelName.length - 1 ? this.currentIndex + 1 : null
        case 'next2':
          return this.currentIndex < this.levelName.length - 2 ? this.currentIndex + 2 : null
        default:
          return this.currentIndex
      }
    },
    getImageSrc(state) {
      const index = this.getTierIndex(state)
      if (index === null || index < 0 || index >= this.levelName.length) {
        return '' // Return an empty string if index is out of bounds
      }
      const color = this.levelName[index]
      return `${color}`
    },
    getImageSrcHalfLeft(state) {
      const index = this.getTierIndex(state)
      if (index === null) {
        return ''
      }
      const color = this.levelName[index]
      return SHARED.MEDIA_SERVER_URL + `/vipTier/${color}_left.png`
    },
    getImageSrcHalfRight(state) {
      const index = this.getTierIndex(state)
      if (index === null) {
        return ''
      }
      const color = this.levelName[index]
      return SHARED.MEDIA_SERVER_URL + `/vipTier/${color}_right.png`
    },
    previousTier() {
      if (!this.isFirstTier) {
        this.currentTierIndex--
      }
    },
    nextTier() {
      if (!this.isLastTier) {
        this.currentTierIndex++
      }
    },
    formatCurrency(amount) {
      // Use currencySymbolMapp to get the symbol based on currentCurrency
      const symbol = this.currencySymbolMapp(this.currentCurrency)
      return amount ? `${symbol}${amount}` : '' // Add currency symbol only if amount is not empty
    },
    getMaxWidth(index) {
      const totalIcons = this.images.length
      const middleIndex = Math.floor(totalIcons / 2) // middle index will be 2 when there are 5 images

      if (index === 0 || index === 4) {
        return 180
      } else if (index === 1 || index === 3) {
        return 220
      } else if (index === 2) {
        return 260
      } else {
        return 180
      }
    },
    metaTag() {
      const currentUrl = window.location.href
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    showPreviousLevel() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    showNextLevel() {
      if (this.currentIndex < this.levelName.length - 1) {
        this.currentIndex++
      }
    }
  }
}
</script>

<style lang="scss">
.findMoreButton {
  font-size: 26px !important;
  background: linear-gradient(180deg, #47206F 0, #280B45 62%) !important;
  border-radius: 12px !important;
  color: #ffffff !important;
}
.tier-nextPass {
  min-width: 20px !important;
}
.nameCover {
  //border-radius: 10px;
  padding: 5px;

  font-size: 13px;
  width: 90px;
  text-align: center;
}
.newMember {
  color: #47206F !important;
}
.bronze {
  color: #9F6A40 !important;
}
.silver {
  color: #474749 !important;
}
.gold {
  color: #987918 !important;
}
.ruby {
  color: #861B1B !important;
}
.platinium {
  color: #6D6F73 !important;
}
.diamond {
  color: #648895 !important;
}
.nameCoverETC {
  //border: 1px solid #575757;
  color: transparent;
  border-radius: 10px;
  padding: 5px;
  font-size: 13px;
  width: 60px;
  text-align: center;
}
.fade {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 50%; /* Adjust this to control the fade starting point */
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  pointer-events: none; /* Ensures the gradient overlay is non-interactive */
}
.otherTierImage {
  opacity: 0.25;
}
.text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tncFaqTitle {
  font-size: 18px !important;
}
.col-padding {
  height: 40px;
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: 15px !important;
  .headerTable {
    display: flex;
    justify-content: start;
    align-items: center;
  }
}
.col-border {
  padding-left: 15px !important;
  display: flex;
  justify-content: start;
  align-items: center;
}
.border_left {
  //height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tierDetail-card {
  background: #2c2c2c !important;
}
.coveredRow {
  background: linear-gradient(180deg, #47206F 0%, #280B45 62%);
  border-radius: 15px;
}
.uncoveredRow {
}
.headerTable {
  font-size: 18px;
}
.vip-tiermobile {
  background: #ffffff;
}
.vipGirlImg {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}
.be-vip-container {
  border: 2px solid #ffce01;
  border-radius: 25px;
  background: #1e1e1e;
}
.level-Names {
  background: white;
  border-radius: 15px;
  color: black;
  padding: 5px;
  width: 85px;
}
.category-Title {
  font-size: 18px !important;
}
.bigger-col {
  width: 25%; /* Adjust as needed */
}
.descriptionVipText {
  font-size: 18px;
}
.bigger-img {
  width: 100%; /* Adjust as needed */
  height: auto; /* Ensures image proportions are maintained */
}
.cashGirl {
  position: absolute;
  top: 30%;
  right: 3%;
  height: 70%;
}
.tncFaqCol {
  max-width: 45%;
}
.rankName {
  background-color: #ffffff80;
  border-radius: 15px;
  height: 35px;
  width: 90px;
}
.vipTable_bg {
  background: linear-gradient(180deg, #47206F 0%, #280B45 62%);
  border-radius: 20px;
}
.level-col {
  display: flex;
  align-items: center;
  //width: 100px;
  //height: 100px;
}

//.level-col.scale-up {
//  transform: scale(1.2); /* Adjust the scale factor as needed */
//}
.joinVipText {
  font-size: 18px;
}
.height-of-tier {
  height: 350px;
}
.menuBar {
  position: absolute;
  z-index: 5;
  width: 100%;
}
//.menuBarWrapper {
//  max-width: 1320px;
//}
.be-vip {
  //background: #1e1e1e;
}
.text-vip {
  position: absolute;
  bottom: 1%;
  left: 25%;
  width: 600px;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 30px;
  text-align: left;
}
.img-vip {
  position: absolute;
  bottom: 20%;
  left: 24%;
  transform: translate(-50%, -50%);
  text-align: left;
}
.infospace {
  width: 55%;
}
.vip-all-tier-desktop {
  height: 132px !important;
  min-width: 48px !important;
  width: 96px !important;
  border-radius: 0px;
  overflow: inherit;
  margin: 10px 28px 0px;
  display: flex;
  flex-direction: column;
}
.vipcard_asset {
  height: 250px;
  width: 250px;
}
.tierpng {
  height: 90px !important;
  min-width: 48px !important;
  width: 80px !important;
}
.tierpngHalf {
  height: 90px !important;
  min-width: 24px !important;
  width: 40px !important;
}
.middleTier {
  padding: 0 6px !important;
}
.btnleft {
  background-color: transparent !important;
  z-index: 1;
  color: #000 !important;
  padding: 0 8px !important;
}

.btnright {
  background-color: transparent !important;
  z-index: 1;
  color: #000 !important;
  padding: 0 8px !important;
}
.title3 {
  font-size: 18px;
  color: #ff860c;
}
.leftside {
  justify-content: center;
  align-items: center;
  display: flex;
}
.downsideFAQ {
  border-radius: 10px;
  width: 100%;
  background: #002b16;
  padding: 20px;
  p {
    font-size: 12px;
  }
}
.upsideTNC {
  border-radius: 10px;
  width: 100%;
  background: #002b16;
  padding: 20px;
  p {
    font-size: 12px;
  }
}

.lines {
  color: #00ffb1;
  font-size: 24px;
  margin-bottom: 10px;
}
.linesmobile {
  justify-content: center;
  display: flex;
  color: #00ffb1;
  font-size: 14px;
  margin-bottom: 10px !important;
}
.v-progress-linear__determinate {
  border-radius: 13px;
  //height: 12px;
}
.rightside {
  display: flex;
  flex-direction: column;
  width: 70%;
  margin-left: 8%;
}
.custom-divider {
  padding: 0px !important;
  border-width: 0.8px !important;
  border-color: #00ffb1 !important;
  //border-image: linear-gradient(45deg,  #002A20, #00FFB1) 1;
  height: 100%;
  margin-left: 20px;
  margin-right: 20px;
}
.v-progress-linear__background {
  background-color: #00543d !important;
  opacity: 1 !important;
}

.viptitle {
  color: #ff860c;
  text-align: center;
  font-size: 18px;
  //background-color: #0a0637;
}
.titledesktop {
  color: #ffffff;
  text-align: left;
  font-size: 18px;
  //background-color: #0a0637;
  padding-left: 20px;
}
.title2 {
  color: #ff860c;
  font-size: 18px;
  margin-top: 25px;
}

.titlewithbackgroundcolor {
  font-size: 18px;
  color: #ffffff;
  padding-left: 20px;
  background-color: #003b26;
  padding-top: 10px;
  padding-bottom: 10px;
  //margin-left: -20px;
  //margin-right: -20px;
}
.border_left {
  border-left: 2px solid #FF9E2D;
  border-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.border_left:first-child {
  border-left: none;
}
th,
td {
  padding: 8px;
}

.v-expand-transition p {
  font-size: 12px;
}
.faqbtn,
.tncbtn {
  background-color: #fd8839 !important;
  justify-content: start;
  color: #fff !important;
}

.triangle {
  width: 0;
  height: 0;
  right: 0;
  position: absolute;
  border-style: solid;
  border-width: 0 5px 5px 5px;
  border-color: transparent transparent #fff transparent;
}

.triangle.up {
  transform: translate(-50%, -50%) rotate(180deg);
  top: 60%;
}

.triangle.down {
  transform: translate(-50%, -50%);
  top: 40%;
}
.faq-tnc-container {
  width: 100%;
  background-color: #fd8839 !important;
  border-radius: 5px;
}
.vip-tier {
  padding: 20px 20px 0px;
  color: white;
}
.vip-tierdesktop {
  padding: 2% 12% !important;
  color: black;
  background: #fff;
}
.vip-level-upgrade-info {
  display: flex;
  justify-content: center;
  padding: 20px;
  color: white;
}
.vip-level-upgrade-info-inner {
  background-image: url('/static/svg/vipassets/How_to_Join_MobileBg.jpg');
  background-size: contain;
  background-position-y: bottom;
  height: 590px;
  width: 100%;
  padding: 15px;
  border: 2px solid #ff860c;
  border-radius: 5px;
}
.vip-level-upgrade-info-inner-desktop {
  background-image: url('/static/svg/vipassets/How_to_Join_DesktopBg.jpg');
  background-size: cover;
  height: 400px;
  width: 100%;
  padding: 15px;
  border: 2px solid #ff860c;
  border-radius: 5px;
}
.be-kk-vip {
  //background-color: #060936;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  font-size: 24px !important;
  padding-top: 20px;
}
.vip-benefits {
  //background-color: #060936;
  color: #ff860c;
  padding-top: 20px;
  margin-bottom: 16px;
}
.vip-tier-mobile {
  display: none !important;
}
.upgrade-requirement {
  //background-color: #060936;
  color: #ff860c;
  margin-bottom: 16px;
}
.retention-requirement {
  //background-color: #060936;
  color: #ff860c;
}
.pp {
  font-size: 14px;
  color: #fff;
  margin-bottom: 0px !important;

  &.club {
    padding-top: 5px;
    color: #c16d2d !important;
    text-transform: none;
  }
  &.diamond {
    padding-top: 5px;
    color: #b4b5b5 !important;
    text-transform: none;
  }
  &.heart {
    padding-top: 5px;
    color: #d9974a !important;
    text-transform: none;
  }
  &.spade {
    padding-top: 5px;
    color: #66c6ce !important;
    text-transform: none;
  }
  &.ace {
    padding-top: 5px;
    color: #ca8be1 !important;
    text-transform: none;
  }
  &.raja {
    padding-top: 5px;
    color: #ffffff !important;
    text-transform: none;
  }
}

.pp-dot::before {
  content: "•";
  color: white;
  margin-right: 2px;
}

.lefttext {
  text-align: left;
  color: white;
  font-size: 12px;
}
.lefttextdesktop {
  text-align: left;
  color: white;
  padding: 20px 0px;
  font-size: 14px;
  margin-bottom: 0px !important;
}
.righttext {
  text-align: right;
  color: #ffffff;
  font-size: 12px;
}
.righttextdesktop {
  text-align: center;
  color: white;
  font-size: 14px;
}
.vip-level-upgrade-info p,
.be-kk-vip p {
  font-size: 12px;
}
.blue-text {
  color: #0047ff;
}
.progress-details-col {
  font-size: 15px;
}
.tier-all-png {
  height: auto !important;
  min-width: 48px !important;
  width: 70px !important;
  margin: 7px 11px 0px;
  display: flex;
  flex-direction: column;
}
.tier-all-png-desktop {
  border-radius: 0px;
  overflow: inherit;
  width: 95px !important;
  //height: 90px !important;
  margin: 43px 2.7% 0px;
  display: flex;
  flex-direction: column;
}
.faqspan {
  font-size: 15px;
}

.bevipheader {
  font-size: 32px;
  color: #fff;
  font-weight: normal !important;
  text-align: center;

  @media (max-width: 1095px) {
    font-size: 26px;
  }
}

.headertext {
  font-size: 24px;
  color: #fff;
  text-align: start;
  padding-bottom: 20px;
  font-weight: normal !important;
}
.descriptionText {
  font-size: 12px;
}
.tableText {
  font-size: 14px;
}
//@media (max-width: 1600px) {
//  .vipcard_asset{
//    height: 200px;
//    width: 200px;
//  }
//  .tier-all-png-desktop {
//    width: 135px !important;
//    height: 80px !important;
//    margin: 3px 2px 0px;
//  }
//  .vip-all-tier-desktop {
//    height: 120px !important;
//    min-width: 48px !important;
//    width: 140px !important;
//    margin: 7px 6px 0px;
//  }
//}
//@media (max-width: 1500px){
//  .tier-all-png-desktop {
//    width: 115px !important;
//    height: 74px !important;
//    margin: 3px 4px 0px;
//  }
//  .vip-all-tier-desktop {
//    height: 105px !important;
//    min-width: 48px !important;
//    width: 125px !important;
//    margin: 7px 6px 0px;
//  }
//}
//
//
@media (min-width: 1600px) {
  .height-of-tier {
    height: 400px;
  }
}
@media (min-width: 2000px) {
  .height-of-tier {
    height: 450px;
  }
}

@media (max-width: 1500px) {
  .tier-all-png-desktop {
    width: 102px !important;
    //height: 60px !important;
    margin: 43px 13px 0px;
  }
  .vip-all-tier-desktop {
    height: auto !important;
    max-width: 100px !important;
    margin: 7px 22px 0px;
  }
}
@media (max-width: 1400px) {
  .cashGirl {
    position: absolute;
    top: 30%;
    right: -2%;
    height: 70%;
  }
  .text-vip {
    bottom: -7%;
    left: 27%;
    width: 600px;
  }
  .img-vip {
    bottom: 14%;
    left: 26%;
    width: 600px;
  }
  .tier-all-png-desktop {
    width: 96px !important;
    //height: 55px !important;
    margin: 43px 9px 0px;
  }
  .vip-all-tier-desktop {
    margin: 7px 17px 0px;
  }
}
@media (min-width: 1700px) {
  .img-vip {
    left: 24%;
    bottom: 25%;
    width: 700px;
  }
  .text-vip {
    left: 25%;
    bottom: 6%;
    width: 700px;
  }
  .joinVipText {
    font-size: 32px;
  }
}
//
//@media (max-width: 1280px){
//  .tier-all-png-desktop {
//    width: 106px !important;
//    height: 60px !important;
//    margin: 3px 3px 0px;
//  }
//}
@media screen and (max-width: 1280px) {
  .text-vip {
    left: 32%;
    bottom: -9%;
  }
  .img-vip {
    left: 32%;
    bottom: -6%;
  }
  .tier-all-png-desktop {
    width: 90px !important;
    //height: 50px !important;
    margin: 53px 9px 0px;
  }
  .vip-all-tier-desktop {
    margin: 7px 13px 0px;
  }
  .tier-img {
    height: auto !important;
    max-width: 80px !important;
  }
}

@media (max-width: 1190px) {
  .tier-all-png-desktop {
    width: 72px !important;
    //height: 43px !important;
    margin: 53px 11px 0px;
  }
  .vip-all-tier-desktop {
    //height: 144px !important;
    //width: 105px !important;
    margin: 7px 12px 0px;
    max-width: 90px !important;
  }
}

@media (max-width: 1095px) {
  .headertext {
    font-size: 18px;
    padding-bottom: 10px;
  }
  .descriptionVipText {
    font-size: 16px;
    margin-bottom: 6px !important;
  }
  .text-vip {
    left: 30%;
  }
  .title2 {
    margin-bottom: 0px !important;
  }
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .tier-all-png-desktop {
    //height: 51px !important;
    margin: 53px 10px 0px;
  }
  .tier-img {
    max-width: 77px !important;
  }
  .vip-all-tier-desktop {
    max-width: 83px !important;
  }
  .infospace {
    width: 65%;
  }
}
@media (max-width: 1000px) {
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .tier-all-png-desktop {
    //height: 43px !important;
    margin: 53px 6px 0px;
  }
  .tier-img {
    max-width: 65px !important;
  }
  .infospace {
    width: 70%;
  }
  .vip-all-tier-desktop {
    height: 106px !important;
    width: 77px !important;
    margin: 10px 11px 7px;
  }
}
@media (max-width: 950px) {
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .tier-all-png-desktop {
    width: 70px !important;
    //height: 43px !important;
    margin: 53px 5px 0px;
  }
  .vip-all-tier-desktop {
    margin: 7px 8px 0px;
  }
}
@media (max-width: 900px) {
  .infospace {
    width: 80%;
  }
  .vip-level-upgrade-info-inner-desktop {
    width: 100%;
  }
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .tier-all-png-desktop {
    width: 57px !important;
    //height: 35px !important;
    margin: 53px 5px 0px;
  }
  .tier-img {
    max-width: 59px !important;
  }
  .vip-all-tier-desktop {
    //height: 60px !important;
    //min-width: 48px !important;
    //width: 70px !important;
    margin: 7px 4px 0px;
  }
  .text-vip {
    left: 35%;
    font-size: 25px;
  }
}
@media screen and (min-width: 650px) and (max-width: 1300px) {
  .vip-tier-mobile-banner {
    display: none !important;
  }
  .vip-tier-mobile {
    display: block !important;
  }
}
@media (max-width: 850px) {
  .headertext {
    font-size: 16px;
    padding-bottom: 10px;
  }
  .descriptionVipText {
    font-size: 10px;
    margin-bottom: 6px !important;
  }
  .beVipText {
    font-size: 18px;
    padding-bottom: 5px;
  }
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .infospace {
    width: 100%;
  }
  .vip-all-tier-desktop {
    height: 92px !important;
    min-width: 48px !important;
    width: 67px !important;
    margin: 7px 4px 0px;
  }
  .tier-all-png-desktop {
    width: 50px !important;
    //height: 29px !important;
    margin: 53px 5px 0px;
  }
  .tier-img {
    max-width: 48px !important;
  }
}

@media (max-width: 540px) {
  .findMoreButton {
    font-size: 14px !important;
    border-radius: 15px !important;
  }
  .headerTable {
    font-size: 14px;
  }
  .tableText {
    font-size: 12px;
  }
  .descriptionVipText {
    font-size: 13px;
    margin-bottom: 6px !important;
  }
  .beVipText {
    font-size: 16px;
  }
  .title3 {
    font-size: 16px;
  }
  .title2 {
    font-size: 16px;
  }
  .titlewithbackgroundcolor {
    font-size: 16px;
  }
  .h1 {
    font-size: 16px;
  }
}

@media (max-width: 500px) and (min-width: 451px) {
  .descriptionVipText {
    font-size: 13px;
    margin-bottom: 6px !important;
  }
  .headertext {
    font-size: 16px;
  }
  .beVipText {
    padding-bottom: 15px;
  }
}

@media (max-width: 650px) and (min-width: 490px) {
  .descriptionVipText {
    font-size: 16px;
    margin-bottom: 6px !important;
  }
  .headertext {
    font-size: 18px;
  }
  .beVipText {
    padding-bottom: 15px;
  }
}
@media (max-width: 490px) {
  .title3,
  .faqspan {
    font-size: 14px !important;
  }
  .title2 {
    font-size: 14px;
  }
  .titlewithbackgroundcolor {
    font-size: 14px;
  }
  .headertext {
    font-size: 17px;
  }
  .lefttext,
  .righttext,
  .vip-level-upgrade-info p,
  .be-kk-vip p {
    font-size: 12px;
  }
  .pp {
    font-size: 12px;
  }
  .btnleft {
    height: 30px !important;
    min-width: 10px !important;
  }
  .btnright {
    height: 30px !important;
    min-width: 10px !important;
  }
}

@media (max-width: 440px) {
  .beVipText {
    font-size: 12px;
  }
  .nameCover {
    padding: 2px;
    font-size: 12px;
    width: 65px;
  }
  .nameCoverETC {
    padding: 2px;
    font-size: 10px;
    width: 48px;
  }
  .vip-tier,
  .titlewithbackgroundcolor {
    padding: 8px;
  }
  .tierpng {
    height: 75px !important;
    min-width: 36px !important;
    width: 70px !important;
  }
  .tierpngHalf {
    height: 75px !important;
    min-width: 24px !important;
    width: 35px !important;
  }
  //.lefttext, .righttext ,.vip-level-upgrade-info p,
  //.be-kk-vip p, .pp {
  //  font-size: 9px;
  //}
  .title3,
  .faqspan {
    font-size: 12px !important;
  }
  .vip-level-upgrade-info-inner {
    height: 780px;
  }
  .titlewithbackgroundcolor {
    font-size: 12px;
  }
  .headertext {
    font-size: 16px;
  }
  .title2 {
    font-size: 12px;
  }
  .tier-all-png {
    margin: 7px 2% 0px;
  }
  .btnleft {
    height: 25px !important;
    min-width: 10px !important;
  }
  .btnright {
    height: 25px !important;
    min-width: 10px !important;
  }
}
@media (max-width: 390px) {
  .headerTable {
    font-size: 12px;
  }
  .tableText {
    font-size: 10px;
  }
  .descriptionVipText {
    font-size: 12px;
    margin-bottom: 6px !important;
  }
  .headertext {
    font-size: 16px;
  }
  .beVipText {
    padding-bottom: 5px;
  }
  .middleTier {
    padding: 0px !important;
  }
  .tierpng {
    height: 65px !important;
    min-width: 36px !important;
    width: 55px !important;
  }
  .tierpngHalf {
    height: 65px !important;
    min-width: 24px !important;
    width: 28px !important;
  }
}
@media (max-width: 375px) {
  .beVipText {
    font-size: 10px;
  }
  .tierpng {
    height: 60px !important;
    min-width: 36px !important;
    width: 50px !important;
  }
  .tierpngHalf {
    height: 60px !important;
    min-width: 25px !important;
    width: 25px !important;
  }
  .btnleft {
    height: 20px !important;
    min-width: 10px !important;
  }
  .btnright {
    height: 20px !important;
    min-width: 10px !important;
  }
  .tier-all-png {
    margin: 7px 1% 0px;
    width: 39px !important;
  }
  .progress-details-col {
    font-size: 15px;
  }
}
@media (max-width: 340px) {
  .headerTable {
    font-size: 11px;
  }
  .descriptionVipText {
    font-size: 10px;
    margin-bottom: 6px !important;
  }
  .middleTier {
    padding: 0px !important;
  }
  .tierpng {
    height: 50px !important;
    min-width: 36px !important;
    width: 45px !important;
  }
  .tierpngHalf {
    height: 50px !important;
    min-width: 23px !important;
    width: 23px !important;
  }
  .nameCover {
    padding: 2px;
    font-size: 8px;
    width: 45px;
  }
  .nameCoverETC {
    padding: 2px;
    font-size: 8px;
    width: 45px;
  }
}

@media (max-width: 280px) {
  .tier-all-png {
    height: auto !important;
    min-width: 35px !important;
    width: 35px !important;
    margin: 7px 1% 0px;
  }
  .btnleft {
    height: 15px !important;
    width: 10px !important;
  }
  .btnright {
    height: 15px !important;
    width: 10px !important;
  }
  .tierpng {
    height: 83px !important;
    min-width: 48px !important;
    width: 98px !important;
  }
  .vip-level-upgrade-info-inner {
    height: 834px;
  }
}
</style>
